import type { ComponentProps } from 'react';

import {
  RichTooltip as OriginalRichTooltip,
  RichTooltipContent,
  RichTooltipTrigger,
} from '@mint-lib/tw-components/patterns';

export const RichTooltip = ({
  children,
  description,
  disabled,
  asChild,
  ...contentProps
}: ComponentProps<typeof RichTooltipContent> & {
  disabled?: boolean;
}) => {
  const isDisabled = disabled || !description;

  return (
    <OriginalRichTooltip>
      <RichTooltipTrigger asChild={asChild}>{children}</RichTooltipTrigger>
      {!isDisabled && (
        <RichTooltipContent description={description} {...contentProps} />
      )}
    </OriginalRichTooltip>
  );
};
